import { useId, useRef, useState } from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'

import {
  CloseIcon,
  CloseNoteButton,
  NoteHeader,
  NotePill,
  NoteTextArea,
  PencilIcon,
} from './styles'

/** What the embroidery team will actually read, so it is capped at something they can act on. */
const MAX_NOTE_LENGTH = 500

export type LogoNoteFieldProps = {
  note: string
  onChangeNote(note: string): void
}

export const LogoNoteField: React.FC<LogoNoteFieldProps> = ({ note, onChangeNote }) => {
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: copy, logoFields },
      },
    },
  } = useTranslation()

  const [isOpen, setIsOpen] = useState(note.length > 0)
  const pillRef = useRef<HTMLButtonElement>(null)
  const textAreaRef = useRef<HTMLTextAreaElement>(null)
  const labelId = useId()

  const open = () => {
    setIsOpen(true)
    requestAnimationFrame(() => textAreaRef.current?.focus())
  }

  const close = () => {
    setIsOpen(false)
    requestAnimationFrame(() => pillRef.current?.focus())
  }

  if (!isOpen) {
    return (
      <NotePill ref={pillRef} type='button' onClick={open}>
        <PencilIcon />
        {copy.openNoteLabel}
      </NotePill>
    )
  }

  return (
    <div>
      <NoteHeader as='div'>
        <span id={labelId}>{copy.noteLabel}</span>
        <CloseNoteButton type='button' aria-label={logoFields.closeNote} onClick={close}>
          <CloseIcon />
        </CloseNoteButton>
      </NoteHeader>

      <NoteTextArea
        ref={textAreaRef}
        aria-labelledby={labelId}
        maxLength={MAX_NOTE_LENGTH}
        name='logoNote'
        placeholder={logoFields.notePlaceholder}
        value={note}
        onChange={event => onChangeNote(event.target.value)}
      />
    </div>
  )
}
